import { useStepExecutionLog } from "./data/useStepExecutionLog";
import { Card, Icon, Modal, Stack, Title, Tooltip, useTheme } from "@introist/react-foundation/v2";
import { Skeletons } from "../../components/molecules";
import { formatDateTime } from "../../utils/DatesUtils";
import { DateFormats } from "../../utils/dates";
import { useState } from "react";

export const StepExecutionLog = ({ stepId }: { stepId: string }) => {
  const { theme } = useTheme();
  const { logs } = useStepExecutionLog(stepId);

  const [open, setOpen] = useState(false);

  return (
    <>
      {logs && logs.length > 0 && (
        <Tooltip tooltip={`${logs.length} execution attempts`}>
          <Stack gap="xSmall" onClick={() => setOpen(true)} style={{ cursor: "pointer" }}>
            <Icon name="cycle" color={theme.palette.foreground.dimmed} />
            <Title color={theme.palette.foreground.dimmed}>{logs.length}</Title>
          </Stack>
        </Tooltip>
      )}
      <Modal
        title="Step execution logs"
        open={open}
        onClose={() => setOpen(false)}
        style={{ width: "500px" }}
      >
        <Stack vertical gap="small">
          {logs === undefined && <Skeletons.List />}
          {logs && logs.length === 0 && <Title>No execution attempts</Title>}
          {logs &&
            logs.map(entry => (
              <Card style={{ padding: "var(--spacing-small) var(--spacing-medium)" }}>
                <Stack>
                  <Title>
                    {formatDateTime(entry.timestamp, DateFormats.datetime.withDay.short)}
                  </Title>
                  <Title style={{ marginLeft: "auto" }}>{entry.details}</Title>
                  {entry.success === true && (
                    <Icon name="checkCircle" color={theme.palette.success.default} />
                  )}
                  {entry.success === false && (
                    <Icon name="crossCircle" color={theme.palette.danger.default} />
                  )}
                </Stack>
              </Card>
            ))}
        </Stack>
      </Modal>
    </>
  );
};
